/* @generated from adl module ferovinum.app.stocksync */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_common from './common';
import * as ferovinum_app_db from './db';

export interface StorageLocationLastStockSync {
  locName: string;
  locId: ferovinum_app_db.StorageLocationId;
  lastSyncedDate: (common.LocalDate|null);
}

export function makeStorageLocationLastStockSync(
  input: {
    locName: string,
    locId: ferovinum_app_db.StorageLocationId,
    lastSyncedDate: (common.LocalDate|null),
  }
): StorageLocationLastStockSync {
  return {
    locName: input.locName,
    locId: input.locId,
    lastSyncedDate: input.lastSyncedDate,
  };
}

const StorageLocationLastStockSync_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locName","default":{"kind":"nothing"},"name":"locName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"lastSyncedDate","default":{"kind":"nothing"},"name":"lastSyncedDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"StorageLocationLastStockSync","version":{"kind":"nothing"}}};

export const snStorageLocationLastStockSync: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StorageLocationLastStockSync"};

export function texprStorageLocationLastStockSync(): ADL.ATypeExpr<StorageLocationLastStockSync> {
  return {value : {typeRef : {kind: "reference", value : snStorageLocationLastStockSync}, parameters : []}};
}

export interface StockSyncBalanceUploadReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
}

export function makeStockSyncBalanceUploadReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
  }
): StockSyncBalanceUploadReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
  };
}

const StockSyncBalanceUploadReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}}]}},"name":"StockSyncBalanceUploadReq","version":{"kind":"nothing"}}};

export const snStockSyncBalanceUploadReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncBalanceUploadReq"};

export function texprStockSyncBalanceUploadReq(): ADL.ATypeExpr<StockSyncBalanceUploadReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncBalanceUploadReq}, parameters : []}};
}

export interface ProductBalanceLineItem {
  productCode: string;
  numberOfUnits: ferovinum_app_db.NumberOfUnits;
}

export function makeProductBalanceLineItem(
  input: {
    productCode: string,
    numberOfUnits: ferovinum_app_db.NumberOfUnits,
  }
): ProductBalanceLineItem {
  return {
    productCode: input.productCode,
    numberOfUnits: input.numberOfUnits,
  };
}

const ProductBalanceLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"numberOfUnits","default":{"kind":"nothing"},"name":"numberOfUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ProductBalanceLineItem","version":{"kind":"nothing"}}};

export const snProductBalanceLineItem: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ProductBalanceLineItem"};

export function texprProductBalanceLineItem(): ADL.ATypeExpr<ProductBalanceLineItem> {
  return {value : {typeRef : {kind: "reference", value : snProductBalanceLineItem}, parameters : []}};
}

export interface StockSyncAdjustmentOptionsReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
}

export function makeStockSyncAdjustmentOptionsReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
  }
): StockSyncAdjustmentOptionsReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
  };
}

const StockSyncAdjustmentOptionsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}}]}},"name":"StockSyncAdjustmentOptionsReq","version":{"kind":"nothing"}}};

export const snStockSyncAdjustmentOptionsReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncAdjustmentOptionsReq"};

export function texprStockSyncAdjustmentOptionsReq(): ADL.ATypeExpr<StockSyncAdjustmentOptionsReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncAdjustmentOptionsReq}, parameters : []}};
}

export interface StockSyncNewProdOrdersAdjustmentOptionsReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
  runsThatWillBeCreated: ProdOrderRunToCreate[];
}

export function makeStockSyncNewProdOrdersAdjustmentOptionsReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
    runsThatWillBeCreated: ProdOrderRunToCreate[],
  }
): StockSyncNewProdOrdersAdjustmentOptionsReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
    runsThatWillBeCreated: input.runsThatWillBeCreated,
  };
}

const StockSyncNewProdOrdersAdjustmentOptionsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"runsThatWillBeCreated","default":{"kind":"nothing"},"name":"runsThatWillBeCreated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProdOrderRunToCreate"}},"parameters":[]}]}}]}},"name":"StockSyncNewProdOrdersAdjustmentOptionsReq","version":{"kind":"nothing"}}};

export const snStockSyncNewProdOrdersAdjustmentOptionsReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncNewProdOrdersAdjustmentOptionsReq"};

export function texprStockSyncNewProdOrdersAdjustmentOptionsReq(): ADL.ATypeExpr<StockSyncNewProdOrdersAdjustmentOptionsReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncNewProdOrdersAdjustmentOptionsReq}, parameters : []}};
}

export interface ProductDiff {
  product: common_db.WithDbId<ferovinum_app_db.Product>;
  difference: ferovinum_app_db.NumberOfUnits;
}

export function makeProductDiff(
  input: {
    product: common_db.WithDbId<ferovinum_app_db.Product>,
    difference: ferovinum_app_db.NumberOfUnits,
  }
): ProductDiff {
  return {
    product: input.product,
    difference: input.difference,
  };
}

const ProductDiff_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}]}},{"annotations":[],"serializedName":"difference","default":{"kind":"nothing"},"name":"difference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ProductDiff","version":{"kind":"nothing"}}};

export const snProductDiff: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ProductDiff"};

export function texprProductDiff(): ADL.ATypeExpr<ProductDiff> {
  return {value : {typeRef : {kind: "reference", value : snProductDiff}, parameters : []}};
}

export interface ProductIdDiff {
  productId: common_db.DbKey<ferovinum_app_db.Product>;
  difference: ferovinum_app_db.NumberOfUnits;
}

export function makeProductIdDiff(
  input: {
    productId: common_db.DbKey<ferovinum_app_db.Product>,
    difference: ferovinum_app_db.NumberOfUnits,
  }
): ProductIdDiff {
  return {
    productId: input.productId,
    difference: input.difference,
  };
}

const ProductIdDiff_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}]}},{"annotations":[],"serializedName":"difference","default":{"kind":"nothing"},"name":"difference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ProductIdDiff","version":{"kind":"nothing"}}};

export const snProductIdDiff: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ProductIdDiff"};

export function texprProductIdDiff(): ADL.ATypeExpr<ProductIdDiff> {
  return {value : {typeRef : {kind: "reference", value : snProductIdDiff}, parameters : []}};
}

export interface ProductDiffAdjustmentOptionsWithPendingAndReservedUnits {
  productDiff: ProductDiff;
  adjustmentOptionsWithPendingUnits: NewDealRequestPendingQuantity[];
  adjustmentOptionsWithReservedUnits: ThirdPartySaleReservedQuantity[];
}

export function makeProductDiffAdjustmentOptionsWithPendingAndReservedUnits(
  input: {
    productDiff: ProductDiff,
    adjustmentOptionsWithPendingUnits: NewDealRequestPendingQuantity[],
    adjustmentOptionsWithReservedUnits: ThirdPartySaleReservedQuantity[],
  }
): ProductDiffAdjustmentOptionsWithPendingAndReservedUnits {
  return {
    productDiff: input.productDiff,
    adjustmentOptionsWithPendingUnits: input.adjustmentOptionsWithPendingUnits,
    adjustmentOptionsWithReservedUnits: input.adjustmentOptionsWithReservedUnits,
  };
}

const ProductDiffAdjustmentOptionsWithPendingAndReservedUnits_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productDiff","default":{"kind":"nothing"},"name":"productDiff","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}},{"annotations":[],"serializedName":"adjustmentOptionsWithPendingUnits","default":{"kind":"nothing"},"name":"adjustmentOptionsWithPendingUnits","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewDealRequestPendingQuantity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"adjustmentOptionsWithReservedUnits","default":{"kind":"nothing"},"name":"adjustmentOptionsWithReservedUnits","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ThirdPartySaleReservedQuantity"}},"parameters":[]}]}}]}},"name":"ProductDiffAdjustmentOptionsWithPendingAndReservedUnits","version":{"kind":"nothing"}}};

export const snProductDiffAdjustmentOptionsWithPendingAndReservedUnits: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ProductDiffAdjustmentOptionsWithPendingAndReservedUnits"};

export function texprProductDiffAdjustmentOptionsWithPendingAndReservedUnits(): ADL.ATypeExpr<ProductDiffAdjustmentOptionsWithPendingAndReservedUnits> {
  return {value : {typeRef : {kind: "reference", value : snProductDiffAdjustmentOptionsWithPendingAndReservedUnits}, parameters : []}};
}

export interface NewDealRequestPendingQuantity {
  newDealRequest: common_db.WithDbId<ferovinum_app_db.NewDealRequest>;
  pendingQuantity: ferovinum_app_db.NumberOfUnits;
}

export function makeNewDealRequestPendingQuantity(
  input: {
    newDealRequest: common_db.WithDbId<ferovinum_app_db.NewDealRequest>,
    pendingQuantity: ferovinum_app_db.NumberOfUnits,
  }
): NewDealRequestPendingQuantity {
  return {
    newDealRequest: input.newDealRequest,
    pendingQuantity: input.pendingQuantity,
  };
}

const NewDealRequestPendingQuantity_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"newDealRequest","default":{"kind":"nothing"},"name":"newDealRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NewDealRequest"}},"parameters":[]}]}},{"annotations":[],"serializedName":"pendingQuantity","default":{"kind":"nothing"},"name":"pendingQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"NewDealRequestPendingQuantity","version":{"kind":"nothing"}}};

export const snNewDealRequestPendingQuantity: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"NewDealRequestPendingQuantity"};

export function texprNewDealRequestPendingQuantity(): ADL.ATypeExpr<NewDealRequestPendingQuantity> {
  return {value : {typeRef : {kind: "reference", value : snNewDealRequestPendingQuantity}, parameters : []}};
}

export interface ThirdPartySaleReservedQuantity {
  purchaseRequest: common_db.WithDbId<ferovinum_app_db.PurchaseRequest>;
  reservedQuantity: ferovinum_app_db.NumberOfUnits;
}

export function makeThirdPartySaleReservedQuantity(
  input: {
    purchaseRequest: common_db.WithDbId<ferovinum_app_db.PurchaseRequest>,
    reservedQuantity: ferovinum_app_db.NumberOfUnits,
  }
): ThirdPartySaleReservedQuantity {
  return {
    purchaseRequest: input.purchaseRequest,
    reservedQuantity: input.reservedQuantity,
  };
}

const ThirdPartySaleReservedQuantity_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaseRequest","default":{"kind":"nothing"},"name":"purchaseRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequest"}},"parameters":[]}]}},{"annotations":[],"serializedName":"reservedQuantity","default":{"kind":"nothing"},"name":"reservedQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ThirdPartySaleReservedQuantity","version":{"kind":"nothing"}}};

export const snThirdPartySaleReservedQuantity: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ThirdPartySaleReservedQuantity"};

export function texprThirdPartySaleReservedQuantity(): ADL.ATypeExpr<ThirdPartySaleReservedQuantity> {
  return {value : {typeRef : {kind: "reference", value : snThirdPartySaleReservedQuantity}, parameters : []}};
}

export interface StockSyncPendingAndReservedUnitsAdjustmentReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
  purchaseRequestsToAdvance: common_db.DbKey<ferovinum_app_db.PurchaseRequest>[];
  newDealRequestsToAdvance: common_db.DbKey<ferovinum_app_db.NewDealRequest>[];
}

export function makeStockSyncPendingAndReservedUnitsAdjustmentReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
    purchaseRequestsToAdvance: common_db.DbKey<ferovinum_app_db.PurchaseRequest>[],
    newDealRequestsToAdvance: common_db.DbKey<ferovinum_app_db.NewDealRequest>[],
  }
): StockSyncPendingAndReservedUnitsAdjustmentReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
    purchaseRequestsToAdvance: input.purchaseRequestsToAdvance,
    newDealRequestsToAdvance: input.newDealRequestsToAdvance,
  };
}

const StockSyncPendingAndReservedUnitsAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaseRequestsToAdvance","default":{"kind":"nothing"},"name":"purchaseRequestsToAdvance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequest"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"newDealRequestsToAdvance","default":{"kind":"nothing"},"name":"newDealRequestsToAdvance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NewDealRequest"}},"parameters":[]}]}]}}]}},"name":"StockSyncPendingAndReservedUnitsAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockSyncPendingAndReservedUnitsAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncPendingAndReservedUnitsAdjustmentReq"};

export function texprStockSyncPendingAndReservedUnitsAdjustmentReq(): ADL.ATypeExpr<StockSyncPendingAndReservedUnitsAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncPendingAndReservedUnitsAdjustmentReq}, parameters : []}};
}

export interface StockSyncProdOrdersAdjustmentReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
  runsToCreate: ProdOrderRunToCreate[];
}

export function makeStockSyncProdOrdersAdjustmentReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
    runsToCreate: ProdOrderRunToCreate[],
  }
): StockSyncProdOrdersAdjustmentReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
    runsToCreate: input.runsToCreate,
  };
}

const StockSyncProdOrdersAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"runsToCreate","default":{"kind":"nothing"},"name":"runsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProdOrderRunToCreate"}},"parameters":[]}]}}]}},"name":"StockSyncProdOrdersAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockSyncProdOrdersAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncProdOrdersAdjustmentReq"};

export function texprStockSyncProdOrdersAdjustmentReq(): ADL.ATypeExpr<StockSyncProdOrdersAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncProdOrdersAdjustmentReq}, parameters : []}};
}

export interface StockSyncNewProdOrdersAdjustmentReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
  runsThatWillBeCreated: ProdOrderRunToCreate[];
  newProdOrderRunsToCreate: NewProdOrderRunToCreate[];
}

export function makeStockSyncNewProdOrdersAdjustmentReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
    runsThatWillBeCreated: ProdOrderRunToCreate[],
    newProdOrderRunsToCreate: NewProdOrderRunToCreate[],
  }
): StockSyncNewProdOrdersAdjustmentReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
    runsThatWillBeCreated: input.runsThatWillBeCreated,
    newProdOrderRunsToCreate: input.newProdOrderRunsToCreate,
  };
}

const StockSyncNewProdOrdersAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"runsThatWillBeCreated","default":{"kind":"nothing"},"name":"runsThatWillBeCreated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProdOrderRunToCreate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"newProdOrderRunsToCreate","default":{"kind":"nothing"},"name":"newProdOrderRunsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewProdOrderRunToCreate"}},"parameters":[]}]}}]}},"name":"StockSyncNewProdOrdersAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockSyncNewProdOrdersAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncNewProdOrdersAdjustmentReq"};

export function texprStockSyncNewProdOrdersAdjustmentReq(): ADL.ATypeExpr<StockSyncNewProdOrdersAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncNewProdOrdersAdjustmentReq}, parameters : []}};
}

export interface ProdOrderRunToCreate {
  taskId: common_db.DbKey<ferovinum_app_db.ProductionOrderTask>;
  quantityUsed: ferovinum_app_db.NumberOfUnits;
  quantityProduced: ferovinum_app_db.NumberOfUnits;
}

export function makeProdOrderRunToCreate(
  input: {
    taskId: common_db.DbKey<ferovinum_app_db.ProductionOrderTask>,
    quantityUsed: ferovinum_app_db.NumberOfUnits,
    quantityProduced: ferovinum_app_db.NumberOfUnits,
  }
): ProdOrderRunToCreate {
  return {
    taskId: input.taskId,
    quantityUsed: input.quantityUsed,
    quantityProduced: input.quantityProduced,
  };
}

const ProdOrderRunToCreate_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"taskId","default":{"kind":"nothing"},"name":"taskId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderTask"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quantityUsed","default":{"kind":"nothing"},"name":"quantityUsed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"quantityProduced","default":{"kind":"nothing"},"name":"quantityProduced","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ProdOrderRunToCreate","version":{"kind":"nothing"}}};

export const snProdOrderRunToCreate: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"ProdOrderRunToCreate"};

export function texprProdOrderRunToCreate(): ADL.ATypeExpr<ProdOrderRunToCreate> {
  return {value : {typeRef : {kind: "reference", value : snProdOrderRunToCreate}, parameters : []}};
}

export interface NewProdOrderRunToCreate {
  targetProductId: ferovinum_app_db.ProductId;
  targetProductQuantityProduced: ferovinum_app_db.NumberOfUnits;
  sourceProductId: ferovinum_app_db.ProductId;
  sourceProductQuantityUsed: ferovinum_app_db.NumberOfUnits;
}

export function makeNewProdOrderRunToCreate(
  input: {
    targetProductId: ferovinum_app_db.ProductId,
    targetProductQuantityProduced: ferovinum_app_db.NumberOfUnits,
    sourceProductId: ferovinum_app_db.ProductId,
    sourceProductQuantityUsed: ferovinum_app_db.NumberOfUnits,
  }
): NewProdOrderRunToCreate {
  return {
    targetProductId: input.targetProductId,
    targetProductQuantityProduced: input.targetProductQuantityProduced,
    sourceProductId: input.sourceProductId,
    sourceProductQuantityUsed: input.sourceProductQuantityUsed,
  };
}

const NewProdOrderRunToCreate_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"targetProductId","default":{"kind":"nothing"},"name":"targetProductId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"targetProductQuantityProduced","default":{"kind":"nothing"},"name":"targetProductQuantityProduced","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceProductId","default":{"kind":"nothing"},"name":"sourceProductId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceProductQuantityUsed","default":{"kind":"nothing"},"name":"sourceProductQuantityUsed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"NewProdOrderRunToCreate","version":{"kind":"nothing"}}};

export const snNewProdOrderRunToCreate: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"NewProdOrderRunToCreate"};

export function texprNewProdOrderRunToCreate(): ADL.ATypeExpr<NewProdOrderRunToCreate> {
  return {value : {typeRef : {kind: "reference", value : snNewProdOrderRunToCreate}, parameters : []}};
}

export interface StockSyncPositiveNegativeAdjustments {
  positiveAdjustments: ProductDiff[];
  negativeAdjustments: ProductDiff[];
}

export function makeStockSyncPositiveNegativeAdjustments(
  input: {
    positiveAdjustments: ProductDiff[],
    negativeAdjustments: ProductDiff[],
  }
): StockSyncPositiveNegativeAdjustments {
  return {
    positiveAdjustments: input.positiveAdjustments,
    negativeAdjustments: input.negativeAdjustments,
  };
}

const StockSyncPositiveNegativeAdjustments_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"positiveAdjustments","default":{"kind":"nothing"},"name":"positiveAdjustments","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"negativeAdjustments","default":{"kind":"nothing"},"name":"negativeAdjustments","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}]}}]}},"name":"StockSyncPositiveNegativeAdjustments","version":{"kind":"nothing"}}};

export const snStockSyncPositiveNegativeAdjustments: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncPositiveNegativeAdjustments"};

export function texprStockSyncPositiveNegativeAdjustments(): ADL.ATypeExpr<StockSyncPositiveNegativeAdjustments> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncPositiveNegativeAdjustments}, parameters : []}};
}

export interface DiffAdjustmentOptionsWithProdOrders {
  sourceProductDiff: ProductDiff;
  targetProductDiff: ProductDiff;
  adjustmentOptions: DiffAdjustmentOptionWithExistingTask[];
}

export function makeDiffAdjustmentOptionsWithProdOrders(
  input: {
    sourceProductDiff: ProductDiff,
    targetProductDiff: ProductDiff,
    adjustmentOptions: DiffAdjustmentOptionWithExistingTask[],
  }
): DiffAdjustmentOptionsWithProdOrders {
  return {
    sourceProductDiff: input.sourceProductDiff,
    targetProductDiff: input.targetProductDiff,
    adjustmentOptions: input.adjustmentOptions,
  };
}

const DiffAdjustmentOptionsWithProdOrders_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceProductDiff","default":{"kind":"nothing"},"name":"sourceProductDiff","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}},{"annotations":[],"serializedName":"targetProductDiff","default":{"kind":"nothing"},"name":"targetProductDiff","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}},{"annotations":[],"serializedName":"adjustmentOptions","default":{"kind":"nothing"},"name":"adjustmentOptions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"DiffAdjustmentOptionWithExistingTask"}},"parameters":[]}]}}]}},"name":"DiffAdjustmentOptionsWithProdOrders","version":{"kind":"nothing"}}};

export const snDiffAdjustmentOptionsWithProdOrders: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"DiffAdjustmentOptionsWithProdOrders"};

export function texprDiffAdjustmentOptionsWithProdOrders(): ADL.ATypeExpr<DiffAdjustmentOptionsWithProdOrders> {
  return {value : {typeRef : {kind: "reference", value : snDiffAdjustmentOptionsWithProdOrders}, parameters : []}};
}

export interface DiffAdjustmentOptionsWithNewProdOrders {
  sourceProductDiff: ProductDiff;
  sourceUnitsRemaining: ferovinum_app_db.NumberOfUnits;
  /**
   * Multiple target products can be produced from a single source product. For example applying different labels to a bottle will produce different products.
   */
  targetProducts: NewProdOrderTargetProduct[];
}

export function makeDiffAdjustmentOptionsWithNewProdOrders(
  input: {
    sourceProductDiff: ProductDiff,
    sourceUnitsRemaining: ferovinum_app_db.NumberOfUnits,
    targetProducts: NewProdOrderTargetProduct[],
  }
): DiffAdjustmentOptionsWithNewProdOrders {
  return {
    sourceProductDiff: input.sourceProductDiff,
    sourceUnitsRemaining: input.sourceUnitsRemaining,
    targetProducts: input.targetProducts,
  };
}

const DiffAdjustmentOptionsWithNewProdOrders_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceProductDiff","default":{"kind":"nothing"},"name":"sourceProductDiff","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceUnitsRemaining","default":{"kind":"nothing"},"name":"sourceUnitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[{"value":"Multiple target products can be produced from a single source product. For example applying different labels to a bottle will produce different products.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"targetProducts","default":{"kind":"nothing"},"name":"targetProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewProdOrderTargetProduct"}},"parameters":[]}]}}]}},"name":"DiffAdjustmentOptionsWithNewProdOrders","version":{"kind":"nothing"}}};

export const snDiffAdjustmentOptionsWithNewProdOrders: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"DiffAdjustmentOptionsWithNewProdOrders"};

export function texprDiffAdjustmentOptionsWithNewProdOrders(): ADL.ATypeExpr<DiffAdjustmentOptionsWithNewProdOrders> {
  return {value : {typeRef : {kind: "reference", value : snDiffAdjustmentOptionsWithNewProdOrders}, parameters : []}};
}

export interface NewProdOrderTargetProduct {
  targetProductDiff: ProductDiff;
  finishingService: common_db.WithDbId<ferovinum_app_db.FinishingService>;
}

export function makeNewProdOrderTargetProduct(
  input: {
    targetProductDiff: ProductDiff,
    finishingService: common_db.WithDbId<ferovinum_app_db.FinishingService>,
  }
): NewProdOrderTargetProduct {
  return {
    targetProductDiff: input.targetProductDiff,
    finishingService: input.finishingService,
  };
}

const NewProdOrderTargetProduct_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"targetProductDiff","default":{"kind":"nothing"},"name":"targetProductDiff","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductDiff"}},"parameters":[]}},{"annotations":[],"serializedName":"finishingService","default":{"kind":"nothing"},"name":"finishingService","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FinishingService"}},"parameters":[]}]}}]}},"name":"NewProdOrderTargetProduct","version":{"kind":"nothing"}}};

export const snNewProdOrderTargetProduct: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"NewProdOrderTargetProduct"};

export function texprNewProdOrderTargetProduct(): ADL.ATypeExpr<NewProdOrderTargetProduct> {
  return {value : {typeRef : {kind: "reference", value : snNewProdOrderTargetProduct}, parameters : []}};
}

export interface StockSyncSaveReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  purchaseRequestsToAdvance: common_db.DbKey<ferovinum_app_db.PurchaseRequest>[];
  newDealRequestsToAdvance: common_db.DbKey<ferovinum_app_db.NewDealRequest>[];
  runsToCreate: ProdOrderRunToCreate[];
  newTankProdOrderRunsToCreate: NewTankProdOrderData[];
  newProdOrderRunsToCreate: NewProdOrderRunToCreate[];
}

export function makeStockSyncSaveReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    purchaseRequestsToAdvance: common_db.DbKey<ferovinum_app_db.PurchaseRequest>[],
    newDealRequestsToAdvance: common_db.DbKey<ferovinum_app_db.NewDealRequest>[],
    runsToCreate: ProdOrderRunToCreate[],
    newTankProdOrderRunsToCreate: NewTankProdOrderData[],
    newProdOrderRunsToCreate: NewProdOrderRunToCreate[],
  }
): StockSyncSaveReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    purchaseRequestsToAdvance: input.purchaseRequestsToAdvance,
    newDealRequestsToAdvance: input.newDealRequestsToAdvance,
    runsToCreate: input.runsToCreate,
    newTankProdOrderRunsToCreate: input.newTankProdOrderRunsToCreate,
    newProdOrderRunsToCreate: input.newProdOrderRunsToCreate,
  };
}

const StockSyncSaveReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaseRequestsToAdvance","default":{"kind":"nothing"},"name":"purchaseRequestsToAdvance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequest"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"newDealRequestsToAdvance","default":{"kind":"nothing"},"name":"newDealRequestsToAdvance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NewDealRequest"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"runsToCreate","default":{"kind":"nothing"},"name":"runsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProdOrderRunToCreate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"newTankProdOrderRunsToCreate","default":{"kind":"nothing"},"name":"newTankProdOrderRunsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewTankProdOrderData"}},"parameters":[]}]}},{"annotations":[],"serializedName":"newProdOrderRunsToCreate","default":{"kind":"nothing"},"name":"newProdOrderRunsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewProdOrderRunToCreate"}},"parameters":[]}]}}]}},"name":"StockSyncSaveReq","version":{"kind":"nothing"}}};

export const snStockSyncSaveReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncSaveReq"};

export function texprStockSyncSaveReq(): ADL.ATypeExpr<StockSyncSaveReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncSaveReq}, parameters : []}};
}

export interface StockSyncSaveResp {
}

export function makeStockSyncSaveResp(
  _input: {
  }
): StockSyncSaveResp {
  return {
  };
}

const StockSyncSaveResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"StockSyncSaveResp","version":{"kind":"nothing"}}};

export const snStockSyncSaveResp: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncSaveResp"};

export function texprStockSyncSaveResp(): ADL.ATypeExpr<StockSyncSaveResp> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncSaveResp}, parameters : []}};
}

export interface DiffAdjustmentOptionWithExistingTask {
  orderWithId: common_db.WithDbId<ferovinum_app_db.ProductionOrder>;
  taskWithId: common_db.WithDbId<ferovinum_app_db.ProductionOrderTask>;
  finishingServiceWithId: common_db.WithDbId<ferovinum_app_db.FinishingService>;
  sourceUnitsRemaining: ferovinum_app_db.NumberOfUnits;
  targetUnitsRemaining: ferovinum_app_db.NumberOfUnits;
}

export function makeDiffAdjustmentOptionWithExistingTask(
  input: {
    orderWithId: common_db.WithDbId<ferovinum_app_db.ProductionOrder>,
    taskWithId: common_db.WithDbId<ferovinum_app_db.ProductionOrderTask>,
    finishingServiceWithId: common_db.WithDbId<ferovinum_app_db.FinishingService>,
    sourceUnitsRemaining: ferovinum_app_db.NumberOfUnits,
    targetUnitsRemaining: ferovinum_app_db.NumberOfUnits,
  }
): DiffAdjustmentOptionWithExistingTask {
  return {
    orderWithId: input.orderWithId,
    taskWithId: input.taskWithId,
    finishingServiceWithId: input.finishingServiceWithId,
    sourceUnitsRemaining: input.sourceUnitsRemaining,
    targetUnitsRemaining: input.targetUnitsRemaining,
  };
}

const DiffAdjustmentOptionWithExistingTask_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"orderWithId","default":{"kind":"nothing"},"name":"orderWithId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrder"}},"parameters":[]}]}},{"annotations":[],"serializedName":"taskWithId","default":{"kind":"nothing"},"name":"taskWithId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderTask"}},"parameters":[]}]}},{"annotations":[],"serializedName":"finishingServiceWithId","default":{"kind":"nothing"},"name":"finishingServiceWithId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FinishingService"}},"parameters":[]}]}},{"annotations":[],"serializedName":"sourceUnitsRemaining","default":{"kind":"nothing"},"name":"sourceUnitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"targetUnitsRemaining","default":{"kind":"nothing"},"name":"targetUnitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"DiffAdjustmentOptionWithExistingTask","version":{"kind":"nothing"}}};

export const snDiffAdjustmentOptionWithExistingTask: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"DiffAdjustmentOptionWithExistingTask"};

export function texprDiffAdjustmentOptionWithExistingTask(): ADL.ATypeExpr<DiffAdjustmentOptionWithExistingTask> {
  return {value : {typeRef : {kind: "reference", value : snDiffAdjustmentOptionWithExistingTask}, parameters : []}};
}

export interface StockSyncNewTankProdOrdersOptionsReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
}

export function makeStockSyncNewTankProdOrdersOptionsReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
  }
): StockSyncNewTankProdOrdersOptionsReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
  };
}

const StockSyncNewTankProdOrdersOptionsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}}]}},"name":"StockSyncNewTankProdOrdersOptionsReq","version":{"kind":"nothing"}}};

export const snStockSyncNewTankProdOrdersOptionsReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncNewTankProdOrdersOptionsReq"};

export function texprStockSyncNewTankProdOrdersOptionsReq(): ADL.ATypeExpr<StockSyncNewTankProdOrdersOptionsReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncNewTankProdOrdersOptionsReq}, parameters : []}};
}

export interface StockSyncNewTankProdOrdersOptionsResp {
  /**
   * The quantity of tanks that can be used as source products
   */
  tanks: ferovinum_app_common.ProductQuantity[];
  /**
   * The products that can be produced from the tanks - Either Crown caps or other tanks
   */
  producibleProducts: common_db.WithDbId<ferovinum_app_db.Product>[];
}

export function makeStockSyncNewTankProdOrdersOptionsResp(
  input: {
    tanks: ferovinum_app_common.ProductQuantity[],
    producibleProducts: common_db.WithDbId<ferovinum_app_db.Product>[],
  }
): StockSyncNewTankProdOrdersOptionsResp {
  return {
    tanks: input.tanks,
    producibleProducts: input.producibleProducts,
  };
}

const StockSyncNewTankProdOrdersOptionsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The quantity of tanks that can be used as source products\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"tanks","default":{"kind":"nothing"},"name":"tanks","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductQuantity"}},"parameters":[]}]}},{"annotations":[{"value":"The products that can be produced from the tanks - Either Crown caps or other tanks\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"producibleProducts","default":{"kind":"nothing"},"name":"producibleProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}]}]}}]}},"name":"StockSyncNewTankProdOrdersOptionsResp","version":{"kind":"nothing"}}};

export const snStockSyncNewTankProdOrdersOptionsResp: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncNewTankProdOrdersOptionsResp"};

export function texprStockSyncNewTankProdOrdersOptionsResp(): ADL.ATypeExpr<StockSyncNewTankProdOrdersOptionsResp> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncNewTankProdOrdersOptionsResp}, parameters : []}};
}

/**
 * Represents a product line bottling order.
 * This contains the tanks that are used to produce the crownCaps.
 */
export interface NewTankProdOrderData {
  creationOrder: number;
  tanksUsed: ferovinum_app_common.ProductIdQuantity[];
  productsProduced: ferovinum_app_common.ProductIdQuantity[];
}

export function makeNewTankProdOrderData(
  input: {
    creationOrder: number,
    tanksUsed: ferovinum_app_common.ProductIdQuantity[],
    productsProduced: ferovinum_app_common.ProductIdQuantity[],
  }
): NewTankProdOrderData {
  return {
    creationOrder: input.creationOrder,
    tanksUsed: input.tanksUsed,
    productsProduced: input.productsProduced,
  };
}

const NewTankProdOrderData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[{"value":"Represents a product line bottling order.\nThis contains the tanks that are used to produce the crownCaps.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"creationOrder","default":{"kind":"nothing"},"name":"creationOrder","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"tanksUsed","default":{"kind":"nothing"},"name":"tanksUsed","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductIdQuantity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"productsProduced","default":{"kind":"nothing"},"name":"productsProduced","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductIdQuantity"}},"parameters":[]}]}}]}},"name":"NewTankProdOrderData","version":{"kind":"nothing"}}};

export const snNewTankProdOrderData: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"NewTankProdOrderData"};

export function texprNewTankProdOrderData(): ADL.ATypeExpr<NewTankProdOrderData> {
  return {value : {typeRef : {kind: "reference", value : snNewTankProdOrderData}, parameters : []}};
}

export interface StockSyncNewTankProdOrdersAdjustmentReq {
  locId: ferovinum_app_db.StorageLocationId;
  stockBalance: ProductBalanceLineItem[];
  diffs: ProductIdDiff[];
  tankProdOrders: NewTankProdOrderData[];
}

export function makeStockSyncNewTankProdOrdersAdjustmentReq(
  input: {
    locId: ferovinum_app_db.StorageLocationId,
    stockBalance: ProductBalanceLineItem[],
    diffs: ProductIdDiff[],
    tankProdOrders: NewTankProdOrderData[],
  }
): StockSyncNewTankProdOrdersAdjustmentReq {
  return {
    locId: input.locId,
    stockBalance: input.stockBalance,
    diffs: input.diffs,
    tankProdOrders: input.tankProdOrders,
  };
}

const StockSyncNewTankProdOrdersAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.stocksync","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locId","default":{"kind":"nothing"},"name":"locId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockBalance","default":{"kind":"nothing"},"name":"stockBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductBalanceLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"diffs","default":{"kind":"nothing"},"name":"diffs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"ProductIdDiff"}},"parameters":[]}]}},{"annotations":[],"serializedName":"tankProdOrders","default":{"kind":"nothing"},"name":"tankProdOrders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.stocksync","name":"NewTankProdOrderData"}},"parameters":[]}]}}]}},"name":"StockSyncNewTankProdOrdersAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockSyncNewTankProdOrdersAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.stocksync", name:"StockSyncNewTankProdOrdersAdjustmentReq"};

export function texprStockSyncNewTankProdOrdersAdjustmentReq(): ADL.ATypeExpr<StockSyncNewTankProdOrdersAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockSyncNewTankProdOrdersAdjustmentReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.stocksync.StorageLocationLastStockSync" : StorageLocationLastStockSync_AST,
  "ferovinum.app.stocksync.StockSyncBalanceUploadReq" : StockSyncBalanceUploadReq_AST,
  "ferovinum.app.stocksync.ProductBalanceLineItem" : ProductBalanceLineItem_AST,
  "ferovinum.app.stocksync.StockSyncAdjustmentOptionsReq" : StockSyncAdjustmentOptionsReq_AST,
  "ferovinum.app.stocksync.StockSyncNewProdOrdersAdjustmentOptionsReq" : StockSyncNewProdOrdersAdjustmentOptionsReq_AST,
  "ferovinum.app.stocksync.ProductDiff" : ProductDiff_AST,
  "ferovinum.app.stocksync.ProductIdDiff" : ProductIdDiff_AST,
  "ferovinum.app.stocksync.ProductDiffAdjustmentOptionsWithPendingAndReservedUnits" : ProductDiffAdjustmentOptionsWithPendingAndReservedUnits_AST,
  "ferovinum.app.stocksync.NewDealRequestPendingQuantity" : NewDealRequestPendingQuantity_AST,
  "ferovinum.app.stocksync.ThirdPartySaleReservedQuantity" : ThirdPartySaleReservedQuantity_AST,
  "ferovinum.app.stocksync.StockSyncPendingAndReservedUnitsAdjustmentReq" : StockSyncPendingAndReservedUnitsAdjustmentReq_AST,
  "ferovinum.app.stocksync.StockSyncProdOrdersAdjustmentReq" : StockSyncProdOrdersAdjustmentReq_AST,
  "ferovinum.app.stocksync.StockSyncNewProdOrdersAdjustmentReq" : StockSyncNewProdOrdersAdjustmentReq_AST,
  "ferovinum.app.stocksync.ProdOrderRunToCreate" : ProdOrderRunToCreate_AST,
  "ferovinum.app.stocksync.NewProdOrderRunToCreate" : NewProdOrderRunToCreate_AST,
  "ferovinum.app.stocksync.StockSyncPositiveNegativeAdjustments" : StockSyncPositiveNegativeAdjustments_AST,
  "ferovinum.app.stocksync.DiffAdjustmentOptionsWithProdOrders" : DiffAdjustmentOptionsWithProdOrders_AST,
  "ferovinum.app.stocksync.DiffAdjustmentOptionsWithNewProdOrders" : DiffAdjustmentOptionsWithNewProdOrders_AST,
  "ferovinum.app.stocksync.NewProdOrderTargetProduct" : NewProdOrderTargetProduct_AST,
  "ferovinum.app.stocksync.StockSyncSaveReq" : StockSyncSaveReq_AST,
  "ferovinum.app.stocksync.StockSyncSaveResp" : StockSyncSaveResp_AST,
  "ferovinum.app.stocksync.DiffAdjustmentOptionWithExistingTask" : DiffAdjustmentOptionWithExistingTask_AST,
  "ferovinum.app.stocksync.StockSyncNewTankProdOrdersOptionsReq" : StockSyncNewTankProdOrdersOptionsReq_AST,
  "ferovinum.app.stocksync.StockSyncNewTankProdOrdersOptionsResp" : StockSyncNewTankProdOrdersOptionsResp_AST,
  "ferovinum.app.stocksync.NewTankProdOrderData" : NewTankProdOrderData_AST,
  "ferovinum.app.stocksync.StockSyncNewTankProdOrdersAdjustmentReq" : StockSyncNewTankProdOrdersAdjustmentReq_AST
};
